import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=622979d6&scoped=true&"
import script from "./NewsAdd.vue?vue&type=script&lang=js&"
export * from "./NewsAdd.vue?vue&type=script&lang=js&"
import style0 from "./NewsAdd.vue?vue&type=style&index=0&id=622979d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622979d6",
  null
  
)

export default component.exports